import React from 'react';
import TimelineIcon from '@mui/icons-material/Timeline';

const TimelineSpecialEffect = {
  id: 'timeline',
  name: 'Timeline Effect',
  description: 'Adds a visual timeline connecting dated sections.',
  component: null, // No actual rendering component, effect is logic within layouts
  icon: <TimelineIcon />,
  settings: { // Potential future settings for timeline (e.g., color, line style)
    // lineColor: '#000000',
    // lineStyle: 'solid',
  },
};

export default TimelineSpecialEffect; 